import uniqBy from 'lodash/uniqBy';
import {
  CoachMemberDataFragment,
  GetClientCoachListQuery,
  SelfQuery,
  UserBasicsFragment,
} from '../../graphql/types';

interface GetAvailableCoachesListArgs {
  coachListData: GetClientCoachListQuery;
  selfData: SelfQuery;
  usersList: CoachMemberDataFragment[];
  memberId: string;
  coachSearchValue: string;
}
export function getAvailableCoachesList({
  coachListData,
  selfData,
  usersList,
  memberId,
  coachSearchValue,
}: GetAvailableCoachesListArgs): UserBasicsFragment[] {
  const selectedMember = usersList.find((u) => u.id === memberId);

  const clients = coachListData.self?.coachData?.clients;

  const allCoaches = clients?.edges
    .map(({ node }) => node)
    .filter((client) => {
      if (selectedMember) {
        return selectedMember.fitClient?.id === client.id;
      }
      return true;
    })
    .map((client) => client.coaches.edges.map(({ node }) => node))
    .flat();

  const uniqueCoaches = uniqBy(allCoaches, (node) => node.id);

  const selfFoundInList = uniqueCoaches.find(
    ({ id }) => id === selfData.self?.id,
  );
  const coachIsInSearch =
    selfData.self?.firstName
      ?.toLowerCase()
      .includes(coachSearchValue.toLowerCase()) ||
    selfData.self?.lastName
      ?.toLowerCase()
      .includes(coachSearchValue.toLowerCase());

  if (selfData.self && coachIsInSearch && !selfFoundInList) {
    return [selfData.self, ...uniqueCoaches];
  }

  return uniqueCoaches.sort((a) => (a.id === selfData.self?.id ? -1 : 1));
}
